export const cards = [
  // {
  //   titulo: 'SHEDULE2_0.CARDS.PASO1.TITULO',
  //   completo: false
  // },
  {
    titulo: 'LEADER_GO.SECCION_PROGRAMACION.FECHAS.TITULO',
    completo: false,
    visible: false,
  },
  {
    titulo: 'SHEDULE2_0.CARDS.PASO2.TITULO_CIERRE',
    opcional: true,
    visible: false,
  },
  {
    titulo: 'SHEDULE2_0.CARDS.PASO3.TITULO',
    opcional: true,
    visible: false
  },
  {
    titulo: 'LEADER_GO.SECCION_PROGRAMACION.CORREOS.TITULO',
    opcional: true,
    visible: true
  },
  // {
  //   titulo: 'SHEDULE2_0.CARDS.PASO5.TITULO',
  //   opcional: true,
  //   visible: true
  // },
];

export const secciones = [
  {
    id: 'encuesta',
    titulo: 'SHEDULE2_0.SECCIONES.ENCUESTA.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.ENCUESTA.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.ENCUESTA.ERROR',
    icono: 'insert_drive_file',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'usuarios',
    titulo: 'SHEDULE2_0.SECCIONES.USUARIOS.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.USUARIOS.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.USUARIOS.ERROR',
    icono: 'people',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'NPS',
    titulo: 'SHEDULE2_0.SECCIONES.NPS.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.NPS.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.NPS.ERROR',
    icono: 'face',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Reactivos',
    titulo: 'SHEDULE2_0.SECCIONES.REACTIVOS.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.REACTIVOS.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.REACTIVOS.ERROR',
    icono: 'sentiment_satisfied_alt',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Control',
    titulo: 'SHEDULE2_0.SECCIONES.CONTROL.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.CONTROL.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.CONTROL.ERROR',
    icono: 'control_camera',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Demograficos',
    titulo: 'SHEDULE2_0.SECCIONES.DEMOGRAFICOS.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.DEMOGRAFICOS.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.DEMOGRAFICOS.ERROR',
    icono: 'poll',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Abiertas',
    titulo: 'SHEDULE2_0.SECCIONES.ABIERTAS.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.ABIERTAS.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.ABIERTAS.ERROR',
    icono: 'help_outline',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Forall',
    titulo: 'SHEDULE2_0.SECCIONES.FORALL.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.FORALL.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.FORALL.ERROR',
    icono: 'format_list_numbered',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'Adicionales',
    titulo: 'SHEDULE2_0.SECCIONES.ADICIONALES.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.ADICIONALES.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.ADICIONALES.ERROR',
    icono: 'note_add',
    visible: true,
    completo: false,
    fallo: false
  },
];

export const tipoCorreos = [
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO1.TITULO',
    tipo1: 3,
    tipo2: 4,
    activo: false
  },
  {
    titulo: 'LEADER_GO.SECCION_PROGRAMACION.CORREOS.TIPOS_CORREO.TIPO1_INVITA.TITULO',
    tipo: 1,
    activo: true
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO3.TITULO',
    tipo: 2,
    activo: false
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO6.TITULO',
    tipo: 5,
    activo: false
  },{ //Prueba
    titulo: 'LEADER_GO.SECCION_PROGRAMACION.CORREOS.TIPOS_CORREO.TIPO2_RECOR_NO_INI.TITULO',
    tipo: 6,
    activo: false
  },{
    titulo: 'LEADER_GO.SECCION_PROGRAMACION.CORREOS.TIPOS_CORREO.TIPO3_RECOR_NO_FINA.TITULO',
    tipo: 7,
    activo: false
  },
];
